// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_1f-0";
export var colorSwatch = "_1f-5";
export var compactSwatch = "_1f-7";
export var fillWidth = "_1f-4";
export var iconButton = "_1f-2";
export var iconWrapper = "_1f-3";
export var shadow = "_1f-6";
export var xs = "_1f-1";